import { GlobalStaticDataDocument } from '../../graphql';
import { assertPropsNotNull, setDefaultProps } from '../centre/utils';
export async function getGlobalStaticData(client, country) {
  var _data$giftCards, _data$giftCards$items, _data$giftCards$items2, _data$centres, _data$nationalHomepag, _data$nationalHomepag2, _data$nationalHomepag3;

  const {
    data
  } = await client.query({
    query: GlobalStaticDataDocument,
    context: {
      version: 2
    },
    variables: {
      country
    }
  });

  if (!(data !== null && data !== void 0 && (_data$giftCards = data.giftCards) !== null && _data$giftCards !== void 0 && (_data$giftCards$items = _data$giftCards.items) !== null && _data$giftCards$items !== void 0 && (_data$giftCards$items2 = _data$giftCards$items[0]) !== null && _data$giftCards$items2 !== void 0 && _data$giftCards$items2.navigationMenu)) {
    throw new Error('No data returned giftCards');
  }

  if (!(data !== null && data !== void 0 && (_data$centres = data.centres) !== null && _data$centres !== void 0 && _data$centres.items)) {
    throw new Error('No data returned for centres');
  }

  if (!(data !== null && data !== void 0 && (_data$nationalHomepag = data.nationalHomepage) !== null && _data$nationalHomepag !== void 0 && (_data$nationalHomepag2 = _data$nationalHomepag.items) !== null && _data$nationalHomepag2 !== void 0 && (_data$nationalHomepag3 = _data$nationalHomepag2[0]) !== null && _data$nationalHomepag3 !== void 0 && _data$nationalHomepag3.navigationMenu)) {
    throw new Error('No data returned for nationalHomepage');
  }

  const navObject = data.giftCards.items[0].navigationMenu;
  const giftCards = {
    giftCardNavLinks: navObject.featured,
    navigationMenu: navObject.nav
  };
  const {
    featured: nationalExperienceNavLinks,
    nav: navigationMenu
  } = data.nationalHomepage.items[0].navigationMenu;
  const national = {
    nationalExperienceNavLinks,
    navigationMenu
  };
  const centres = data.centres.items.reduce((arr, item) => {
    if (!item) {
      return arr;
    }

    const centre = setDefaultProps(item, {
      timeZone: 'UTC'
    });
    assertPropsNotNull(centre, ['title', 'suburb', 'state', 'longitude', 'latitude', 'status', 'country', 'slug', 'timeZone'], () => {
      throw new Error('Centre object missing required properties');
    });
    return [...arr, centre];
  }, []);
  return {
    giftCards,
    national,
    centres
  };
}